import styled, { css } from 'styled-components';

import { alignText } from 'utils/constants';
import { generateIndents } from 'utils/generateIndents';

import { AlignText, ThemeColors } from 'types';

export interface BoxProps {
  align?: AlignText;
  backgroundColor?: ThemeColors;
  mv?: number;
  mt?: number;
  mb?: number;
  ph?: number;
  pv?: number;
  pr?: number;
}

const Box = styled.div<BoxProps>`
  position: relative;

  text-align: ${({ align = 'left' }) => alignText[align]};

  ${({ backgroundColor, theme }) =>
    backgroundColor &&
    css`
      background-color: ${theme.colors[backgroundColor]};
    `};

  /* Margins/paddings generator */
  ${props => generateIndents(props)}
`;

export default Box;
